import { Emoji } from 'emoji-mart';
import ReactDOMServer from 'react-dom/server';
import React from 'react';

const startChat = props => async (e, id) => {
  if (e)e.preventDefault();
  props.history.push(`/messages/${id}`);
};


const createEmoji = (e, height = '50px', width = '50px') => {
  const newEmoji = Emoji({
    emoji: e.colons,
    size: 20,
  });
  const newStyle = newEmoji.props.children.props.style;
  const newImg = ReactDOMServer.renderToString(<img
    src={newStyle.backgroundImage.slice(4, -1)}
    className="emoji-input emo-img"
    style={{
      objectPosition: '-99999px 99999px',
      height,
      width,
      backgroundImage: newStyle.backgroundImage,
      backgroundPosition: newStyle.backgroundPosition,
      backgroundSize: newStyle.backgroundSize,
      verticalAlign: 'bottom',
    }}
  />);
  return newImg;
};

const getUnreadCountMessages = (messenger) => {
  let res = 0;
  if (messenger.sortedChannelIds.length) {
    for (let i = 0; i < messenger.sortedChannelIds.length; i += 1) {
      const channel = messenger[messenger.sortedChannelIds[i]];
      if (channel && channel.unread_count) res += channel.unread_count;
    }
  }

  return res;
};

export default {
  startChat,
  createEmoji,
  getUnreadCountMessages,
};



// WEBPACK FOOTER //
// ./src/helpers/messenger.helper.js